module.exports = __webpack_public_path__ + "static/media/mouse-move.f324d1fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pagIndex/icons/mouse-move.svg
// module id = 92
// module chunks = 0